// Shared FTMS safety config.
// Keep this in sync across Bluetooth control logic + UI copy by importing this constant.
export const FTMS_SAFETY_CONFIG = Object.freeze({
  minW: 10,
  maxW: 1500,
  rateLimitMs: 1500,
  resumeCooldownMs: 1000,
  antiJitterW: 1,
});


